import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

import { LotRecommendationType } from './trackLotRecommendationClicked.analytics';

export type LotRecommendationSeenPayload = TrackingPayload & {
    recommendationIds: number[];
    recommendationName: LotRecommendationType;
};

export const trackLotRecommendationSeenAnalytics = (payload: LotRecommendationSeenPayload) => {
    track(TrackingEvents.Item.LotRecommendationSeen, payload);
};
